import axios from 'axios';
import _, { isFunction } from 'lodash';
import { useQuery, useMutation } from '@tanstack/react-query';
import { useState, useMemo, useCallback, createContext, useRef, useEffect, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
import { AnalyticsBrowser } from '@segment/analytics-next';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$i =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$c = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$b = fails$c;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$b(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw$1 = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$a = fails$c;
var classof$7 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$4 = function (it) {
  return IndexedObject$2(requireObjectCoercible$6(it));
};

var isObject$8 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$7 = isObject$8;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$7(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$7(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$7(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$7(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has$a = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$h = global$i;
var isObject$6 = isObject$8;

var document$2 = global$h.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$6(document$2) && isObject$6(document$2.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$2.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$9 = fails$c;
var createElement$1 = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$9(function () {
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$3 = toIndexedObject$4;
var toPrimitive$1 = toPrimitive$2;
var has$9 = has$a;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$9(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$5 = isObject$8;

var anObject$c = function (it) {
  if (!isObject$5(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var DESCRIPTORS$5 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$b = anObject$c;
var toPrimitive = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$5 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPrimitive(P, true);
  anObject$b(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$4 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$8 = DESCRIPTORS$4 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$5 = {exports: {}};

var global$g = global$i;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$8;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$7(global$g, key, value);
  } catch (error) {
    global$g[key] = value;
  } return value;
};

var global$f = global$i;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$f[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$2.inspectSource;

var global$e = global$i;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$e.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$2(WeakMap$1));

var shared$2 = {exports: {}};

var store$1 = sharedStore;

(shared$2.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var shared$1 = shared$2.exports;
var uid$1 = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$d = global$i;
var isObject$4 = isObject$8;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$8;
var objectHas = has$a;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var WeakMap = global$d.WeakMap;
var set$1, get, has$8;

var enforce = function (it) {
  return has$8(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$4(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set$1 = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$8 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    createNonEnumerableProperty$6(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$8 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has$8,
  enforce: enforce,
  getterFor: getterFor
};

var global$c = global$i;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$8;
var has$7 = has$a;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$2 = internalState;

var getInternalState$2 = InternalStateModule$2.get;
var enforceInternalState = InternalStateModule$2.enforce;
var TEMPLATE = String(String).split('String');

(redefine$5.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$7(value, 'name')) createNonEnumerableProperty$5(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global$c) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$5(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState$2(this).source || inspectSource$1(this);
});

var global$b = global$i;

var path$1 = global$b;

var path = path$1;
var global$a = global$i;

var aFunction$6 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$5 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$6(path[namespace]) || aFunction$6(global$a[namespace])
    : path[namespace] && path[namespace][method] || global$a[namespace] && global$a[namespace][method];
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$4 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil)(argument);
};

var toInteger$3 = toInteger$4;

var min$3 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$5 = function (argument) {
  return argument > 0 ? min$3(toInteger$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$2 = toInteger$4;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger$2(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength$4 = toLength$5;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength$4(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var has$6 = has$a;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$6(hiddenKeys$2, key) && has$6(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$6(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$4 = getBuiltIn$5;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$a = anObject$c;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$4('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$a(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$5 = has$a;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$5(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$8 = fails$c;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$8(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$9 = global$i;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$8;
var redefine$4 = redefine$5.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$9;
  } else if (STATIC) {
    target = global$9[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$9[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$4(target, key, sourceProperty, options);
  }
};

var anObject$9 = anObject$c;

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$9(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$7 = fails$c;

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

regexpStickyHelpers.UNSUPPORTED_Y = fails$7(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$7(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$7 = _export;
var exec = regexpExec$2;

$$7({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var fails$6 = fails$c;

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$6(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var global$8 = global$i;
var shared = shared$2.exports;
var has$4 = has$a;
var uid = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global$8.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol$g = function (name) {
  if (!has$4(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has$4(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

// TODO: Remove from `core-js@4` since it's moved to entry points

var redefine$3 = redefine$5.exports;
var fails$5 = fails$c;
var wellKnownSymbol$f = wellKnownSymbol$g;
var regexpExec$1 = regexpExec$2;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$8;

var SPECIES$3 = wellKnownSymbol$f('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$5(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol$f('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$5(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol$f(KEY);

  var DELEGATES_TO_SYMBOL = !fails$5(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$5(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec$1) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine$3(String.prototype, KEY, stringMethod);
    redefine$3(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty$3(RegExp.prototype[SYMBOL], 'sham', true);
};

var requireObjectCoercible$5 = requireObjectCoercible$7;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return Object(requireObjectCoercible$5(argument));
};

var toInteger$1 = toInteger$4;
var requireObjectCoercible$4 = requireObjectCoercible$7;

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible$4($this));
    var position = toInteger$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

var classof$6 = classofRaw$1;
var regexpExec = regexpExec$2;

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof$6(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$8 = anObject$c;
var toObject$3 = toObject$4;
var toLength$3 = toLength$5;
var toInteger = toInteger$4;
var requireObjectCoercible$3 = requireObjectCoercible$7;
var advanceStringIndex = advanceStringIndex$1;
var regExpExec$1 = regexpExecAbstract;

var max = Math.max;
var min$1 = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject$8(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$1(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$3(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min$1(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject$3(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

let apiPrefix;
function getApiPrefix() {
  if (apiPrefix == null) {
    throw new Error('API prefix is not initialized!');
  }
  return apiPrefix;
}
function setApiPrefix(prefix) {
  apiPrefix = prefix;
}
const defaultNavigateFn = path => {
  window.location.replace(path);
};
let navigateFn = defaultNavigateFn;
function getNavigateFn() {
  return navigateFn;
}
function setNavigateFn(navigateFunc) {
  navigateFn = navigateFunc;
}
function isMfe() {
  return window.__POWERED_BY_QIANKUN__;
}

var STORAGE;
(function (STORAGE) {
  STORAGE["WS_TOKEN"] = "WS_TOKEN";
  STORAGE["WS_USER_ID"] = "WS_USER_ID";
  STORAGE["WS_USER_EMAIL"] = "WS_USER_EMAIL";
  STORAGE["WS_IS_SSO"] = "WS_IS_SSO";
  STORAGE["WS_NEED_TO_SELECTE_COMPANY"] = "WS_NEED_TO_SELECTE_COMPANY";
  STORAGE["WS_SELECTED_COMPANY"] = "WS_SELECTED_COMPANY";
  STORAGE["WS_REDIRECT_URL"] = "WS_REDIRECT_URL";
  STORAGE["WS_NEW_WINDOW_PARAM"] = "WS_NEW_WINDOW_PARAM";
  STORAGE["WS_BULK_SELECT_HINT_PARAM"] = "WS_BULK_SELECT_HINT_PARAM";
  STORAGE["WS_IGNORE_SCHEDULING_ADD_EXISTING_MODAL"] = "ws_ignore_scheduling_add_existing_modal";
  STORAGE["WS_GRANT_TEMP_ACCESS_EDIT_POSITION_PAGE"] = "WS_GRANT_TEMP_ACCESS_EDIT_POSITION_PAGE";
  STORAGE["PAYROLL_COMPANY_ID"] = "PAYROLL_COMPANY_ID";
})(STORAGE || (STORAGE = {}));
const USER_PERMISSIONS = {
  EDIT_POSITION: 'edit_position',
  ALL_ADMIN_RIGHTS: 'all_admin_rights',
  EDIT_ALL_CALENDARS: 'edit_all_calendars',
  EDIT_EVALUATION: 'edit_evaluation',
  EDIT_COMPANY: 'edit_company',
  EDIT_DEPARTMENT: 'edit_department',
  EDIT_INTEGRATION: 'edit_integration',
  EDIT_LOCATION: 'edit_location',
  EDIT_MESSAGE: 'edit_message',
  EDIT_FEEDBACK: 'edit_feedback',
  EDIT_NOTE: 'edit_note',
  EDIT_PERMISSION: 'edit_permission',
  EDIT_SPONSORED_JOB: 'edit_sponsored_job',
  MANAGE_ONBOARDING: 'manage_onboarding',
  EDIT_USER: 'edit_user',
  CREATE_POSITION: 'create_position',
  UPDATE_POSITION: 'update_position',
  DELETE_POSITION: 'delete_position',
  EDIT_POSITION_TEMPLATE: 'edit_position_template',
  EDIT_HIRING_PROCESS: 'edit_hiring_process',
  EDIT_HIRING_PROCESS_TEMPLATE: 'edit_hiring_process_template',
  EDIT_JOB_DETAIL: 'edit_job_detail',
  EDIT_JOB_TITLE: 'edit_job_title',
  EDIT_RATE_OF_PAY: 'edit_rate_of_pay',
  EDIT_JOB_TYPE: 'edit_job_and_remote_type',
  EDIT_LOCATION_AND_DEPARTMENT: 'edit_location_and_department',
  EDIT_JOB_DESCRIPTION: 'edit_job_description',
  PUBLISH_POSITION: 'publish_position',
  ONBOARD_EMPLOYEE: 'onboard_employee',
  EDIT_ONBOARDING_PROCESS: 'edit_onboarding_process',
  CUSTOMIZE_NOTIFICATIONS: 'customize_notifications',
  EDIT_CUSTOM_REPORTS: 'edit_custom_reports',
  VIEW_SENSITIVE_PII: 'view_sensitive_pii',
  MANAGE_TEAM_RECORD: 'manage_team_record',
  IMPORT_AND_DELETE_RECORD: 'import_and_delete_record',
  EDIT_RECORD: 'edit_record',
  EDIT_SURVEY: 'edit_survey',
  VIEW_SURVEY_RESULT: 'view_survey_result',
  EDIT_COMPANY_DOCUMENT: 'edit_company_document',
  ASSIGN_COMPANY_DOCUMENT: 'assign_company_document',
  EDIT_CUSTOM_FIELD: 'edit_custom_field',
  EDIT_DATA_EXPORT_TEMPLATE: 'edit_data_export_template',
  EDIT_DATA_EXPORT_REPORT: 'edit_data_export_report',
  CONFIGURE_PAYROLL: 'configure_payroll',
  MANAGE_PAYROLL_OPERATIONS: 'manage_payroll_operations',
  MANAGE_PAYROLL_TEAM_MEMBERS: 'manage_payroll_team_members'
};
const VIEW_SENSITIVE_PII = {
  FULL_ACCESS: 'full_access',
  PARTIAL_ACCESS: 'partial_access'
};
const VIEW_WORKER_SENSITIVE_PII = {
  FULL_ACCESS: 'tr_full_access',
  PARTIAL_ACCESS: 'tr_partial_access'
};
const QUERY_KEYS = {
  GROWTHBOOK_FEATURES: 'GROWTHBOOK_FEATURES',
  CURRENT_USER_INFO: 'CURRENT_USER_INFO',
  CURRENT_USER_PAYROLL_PROFILE: 'CURRENT_USER_PAYROLL_PROFILE',
  AVAILABLE_PERMISSIONS: 'AVAILABLE_PERMISSIONS',
  USER_PERMISSION: 'USER_PERMISSION',
  USER_PERMISSION_V2: 'USER_PERMISSION_V2',
  COMPANIES: 'COMPANIES',
  NOTIFICATION_LIST: 'NOTIFICATION_LIST',
  NOTIFICATION_DETAIL: 'NOTIFICATION_DETAIL',
  BRANDS: 'BRANDS',
  SURVEY_LIST: 'SURVEY_LIST',
  CUSTOM_FIELDS: 'CUSTOM_FIELDS'
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var anObject$7 = anObject$c;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = DESCRIPTORS$3 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$7(O);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn$3 = getBuiltIn$5;

var html$2 = getBuiltIn$3('document', 'documentElement');

var anObject$6 = anObject$c;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$6(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$e = wellKnownSymbol$g;
var create$1 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$e('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var DESCRIPTORS$2 = descriptors;
var fails$4 = fails$c;
var has$3 = has$a;

var defineProperty$2 = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

var arrayMethodUsesToLength$2 = function (METHOD_NAME, options) {
  if (has$3(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has$3(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has$3(options, 0) ? options[0] : thrower;
  var argument1 = has$3(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails$4(function () {
    if (ACCESSORS && !DESCRIPTORS$2) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty$2(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};

var $$6 = _export;
var $includes = arrayIncludes.includes;
var addToUnscopables$1 = addToUnscopables$2;
var arrayMethodUsesToLength$1 = arrayMethodUsesToLength$2;

var USES_TO_LENGTH$1 = arrayMethodUsesToLength$1('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$$6({ target: 'Array', proto: true, forced: !USES_TO_LENGTH$1 }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var global$7 = global$i;

var nativePromiseConstructor = global$7.Promise;

var redefine$2 = redefine$5.exports;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$2(target, key, src[key], options);
  return target;
};

var defineProperty$1 = objectDefineProperty.f;
var has$2 = has$a;
var wellKnownSymbol$d = wellKnownSymbol$g;

var TO_STRING_TAG$3 = wellKnownSymbol$d('toStringTag');

var setToStringTag$3 = function (it, TAG, STATIC) {
  if (it && !has$2(it = STATIC ? it : it.prototype, TO_STRING_TAG$3)) {
    defineProperty$1(it, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var getBuiltIn$2 = getBuiltIn$5;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$c = wellKnownSymbol$g;
var DESCRIPTORS$1 = descriptors;

var SPECIES$2 = wellKnownSymbol$c('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var aFunction$5 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var anInstance$1 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var iterate$2 = {exports: {}};

var iterators = {};

var wellKnownSymbol$b = wellKnownSymbol$g;
var Iterators$4 = iterators;

var ITERATOR$5 = wellKnownSymbol$b('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype[ITERATOR$5] === it);
};

var aFunction$4 = aFunction$5;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$4(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$a = wellKnownSymbol$g;

var TO_STRING_TAG$2 = wellKnownSymbol$a('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var classofRaw = classofRaw$1;
var wellKnownSymbol$9 = wellKnownSymbol$g;

var TO_STRING_TAG$1 = wellKnownSymbol$9('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var classof$4 = classof$5;
var Iterators$3 = iterators;
var wellKnownSymbol$8 = wellKnownSymbol$g;

var ITERATOR$4 = wellKnownSymbol$8('iterator');

var getIteratorMethod$1 = function (it) {
  if (it != undefined) return it[ITERATOR$4]
    || it['@@iterator']
    || Iterators$3[classof$4(it)];
};

var anObject$5 = anObject$c;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$5(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject$5(returnMethod.call(iterator));
    throw error;
  }
};

var anObject$4 = anObject$c;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var toLength$2 = toLength$5;
var bind$2 = functionBindContext;
var getIteratorMethod = getIteratorMethod$1;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate$1 = iterate$2.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind$2(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength$2(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject$4(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate$1.stop = function (result) {
  return new Result(true, result);
};

var wellKnownSymbol$7 = wellKnownSymbol$g;

var ITERATOR$3 = wellKnownSymbol$7('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$3] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$3] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var anObject$3 = anObject$c;
var aFunction$3 = aFunction$5;
var wellKnownSymbol$6 = wellKnownSymbol$g;

var SPECIES$1 = wellKnownSymbol$6('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$3(O).constructor;
  var S;
  return C === undefined || (S = anObject$3(C)[SPECIES$1]) == undefined ? defaultConstructor : aFunction$3(S);
};

var getBuiltIn$1 = getBuiltIn$5;

var engineUserAgent = getBuiltIn$1('navigator', 'userAgent') || '';

var userAgent$1 = engineUserAgent;

var engineIsIos = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent$1);

var global$6 = global$i;
var fails$3 = fails$c;
var classof$3 = classofRaw$1;
var bind$1 = functionBindContext;
var html = html$2;
var createElement = documentCreateElement$1;
var IS_IOS$1 = engineIsIos;

var location = global$6.location;
var set = global$6.setImmediate;
var clear = global$6.clearImmediate;
var process$4 = global$6.process;
var MessageChannel = global$6.MessageChannel;
var Dispatch = global$6.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$6.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof$3(process$4) == 'process') {
    defer = function (id) {
      process$4.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$1(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$6.addEventListener &&
    typeof postMessage == 'function' &&
    !global$6.importScripts &&
    !fails$3(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global$6.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$5 = global$i;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var classof$2 = classofRaw$1;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;

var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
var process$3 = global$5.process;
var Promise$1 = global$5.Promise;
var IS_NODE$1 = classof$2(process$3) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$1(global$5, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$3.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE$1) {
    notify$1 = function () {
      process$3.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    then = promise.then;
    notify$1 = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$1 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global$5, flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aFunction$2 = aFunction$5;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$2(resolve);
  this.reject = aFunction$2(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$2 = anObject$c;
var isObject$3 = isObject$8;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$2(C);
  if (isObject$3(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$4 = global$i;

var hostReportErrors$1 = function (a, b) {
  var console = global$4.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$3 = global$i;
var userAgent = engineUserAgent;

var process$2 = global$3.process;
var versions = process$2 && process$2.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var $$5 = _export;
var global$2 = global$i;
var getBuiltIn = getBuiltIn$5;
var NativePromise = nativePromiseConstructor;
var redefine$1 = redefine$5.exports;
var redefineAll = redefineAll$1;
var setToStringTag$2 = setToStringTag$3;
var setSpecies = setSpecies$1;
var isObject$2 = isObject$8;
var aFunction$1 = aFunction$5;
var anInstance = anInstance$1;
var classof$1 = classofRaw$1;
var inspectSource = inspectSource$3;
var iterate = iterate$2.exports;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var InternalStateModule$1 = internalState;
var isForced = isForced_1;
var wellKnownSymbol$5 = wellKnownSymbol$g;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol$5('species');
var PROMISE = 'Promise';
var getInternalState$1 = InternalStateModule$1.get;
var setInternalState$1 = InternalStateModule$1.set;
var getInternalPromiseState = InternalStateModule$1.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process$1 = global$2.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof$1(process$1) == 'process';
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global$2['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global$2, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global$2, function () {
    if (IS_NODE) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction$1(executor);
    Internal.call(this);
    var state = getInternalState$1(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState$1(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process$1.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$1(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine$1(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $$5({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global$2, arguments));
      }
    });
  }
}

$$5({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$$5({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$$5({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$5({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var isObject$1 = isObject$8;
var classof = classofRaw$1;
var wellKnownSymbol$4 = wellKnownSymbol$g;

var MATCH$1 = wellKnownSymbol$4('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

var isRegExp = isRegexp;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$3 = wellKnownSymbol$g;

var MATCH = wellKnownSymbol$3('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

var $$4 = _export;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$7;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$$4({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible$2(this))
      .indexOf(notARegExp$1(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject$1 = anObject$c;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var sameValue = sameValue$1;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$1(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

function getAuthToken() {
  return window.localStorage.getItem(STORAGE.WS_TOKEN);
}
function setAuthToken(token) {
  window.localStorage.setItem(STORAGE.WS_TOKEN, token);
}
function removeAuthToken() {
  window.localStorage.removeItem(STORAGE.WS_TOKEN);
}
function setWSIsSSO() {
  window.localStorage.setItem(STORAGE.WS_IS_SSO, 'Y');
}
function removeWSIsSSO() {
  window.localStorage.removeItem(STORAGE.WS_IS_SSO);
}
function getSelectedCompany() {
  return window.localStorage.getItem(STORAGE.WS_SELECTED_COMPANY);
}
function setSelectedCompany(value) {
  window.localStorage.setItem(STORAGE.WS_SELECTED_COMPANY, value);
}
function removeSelectedCompany() {
  window.localStorage.removeItem(STORAGE.WS_SELECTED_COMPANY);
}
function getNeedToSelectCompany() {
  return window.localStorage.getItem(STORAGE.WS_NEED_TO_SELECTE_COMPANY);
}
function setNeedToSelectCompany(value) {
  window.localStorage.setItem(STORAGE.WS_NEED_TO_SELECTE_COMPANY, value);
}
function removeNeedToSelectCompany() {
  window.localStorage.removeItem(STORAGE.WS_NEED_TO_SELECTE_COMPANY);
}

var localStorage = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getAuthToken: getAuthToken,
	setAuthToken: setAuthToken,
	removeAuthToken: removeAuthToken,
	setWSIsSSO: setWSIsSSO,
	removeWSIsSSO: removeWSIsSSO,
	getSelectedCompany: getSelectedCompany,
	setSelectedCompany: setSelectedCompany,
	removeSelectedCompany: removeSelectedCompany,
	getNeedToSelectCompany: getNeedToSelectCompany,
	setNeedToSelectCompany: setNeedToSelectCompany,
	removeNeedToSelectCompany: removeNeedToSelectCompany
});

var $$3 = _export;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength$1 = toLength$5;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$7;
var correctIsRegExpLogic = correctIsRegexpLogic;

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$$3({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength$1(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

function isInPasswordFlowOrLoginFlow(pathname = '') {
  return ['/login', '/reset-password/', '/forgot-password', '/select-company'].map(path => pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}${path}`)).includes(true);
}
function isInCustomerSetupFlow(pathname = '') {
  return pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/users/`);
}
function isInSetPasswordFlow(pathname = '') {
  return pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/set-password`);
}
function isInWizardFlow(pathname = '') {
  return pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/setup`);
}
function isInUserWizardFlow(pathname = '') {
  return pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/user-onboarding`);
}
function isJobTargetCallback(pathname = '') {
  return pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/job-target-callback`);
}
function shouldHideGlobalSiders(pathname) {
  return [isInPasswordFlowOrLoginFlow(pathname), isInCustomerSetupFlow(pathname), isInSetPasswordFlow(pathname), pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/redirect`), pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/signup-wizard`), isInWizardFlow(pathname), isInUserWizardFlow(pathname), pathname.startsWith(`${process.env['NX_MFE_SUB_APP_ROUTE_PREFIX_HR']}/podding-setup`), isJobTargetCallback(pathname)].includes(true);
}

const getTimezoneName = () => {
  const {
    timeZone
  } = Intl.DateTimeFormat().resolvedOptions();
  return timeZone;
};

let requestInstance;
function getRequestInstance(options) {
  if (requestInstance == null) {
    requestInstance = createDefaultRequestInstance(options);
  }
  return requestInstance;
}
function setRequestInstance(instance) {
  requestInstance = instance;
}
function createDefaultRequestInstance(options) {
  const instance = axios.create({
    baseURL: getApiPrefix(),
    timeout: 10000
  });
  instance.interceptors.request.use(config => {
    const authToken = getAuthToken();
    const companyId = getSelectedCompany();
    if (authToken != null) {
      config.headers = {
        Authorization: authToken,
        locale: 'en',
        'ws-company-id': companyId,
        'ws-event-path': isMfe() ? `${window.location.pathname}${window.location.search}` : window.location.hash.substring(1),
        TimezoneOffset: String(new Date().getTimezoneOffset()),
        TimezoneName: getTimezoneName()
        // withCredentials?
      };
    }
    return config;
  });
  instance.interceptors.response.use(response => {
    // Redirect user to select company when required by backend
    if (response.headers['require-select-company'] === '1' && !window.location.href.includes('/select-company')) {
      setNeedToSelectCompany('TRUE');
      getNavigateFn()(`/select-company?redirect=${encodeURIComponent(window.location.href)}`);
    }
    return response.data;
  }, error => {
    var _a, _b;
    if (((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error_code) === 10003) {
      removeAuthToken();
      if (!shouldHideGlobalSiders(window.location.pathname)) {
        getNavigateFn()(`/login?redirect=${encodeURIComponent(window.location.href)}`);
      }
    }
    if (isFunction(options === null || options === void 0 ? void 0 : options.beforeReject)) {
      options === null || options === void 0 ? void 0 : options.beforeReject(error);
    }
    return Promise.reject(error);
  });
  return instance;
}

function fetchCurrentUserInfo() {
  return getRequestInstance().get('/v1/users/me');
}
function fetchCurrentUserPayrollProfile() {
  return getRequestInstance().get('/v1/payroll/profiles/current');
}
function logout() {
  return getRequestInstance().post('/v1/sessions/sign_out');
}
const clientLogout = () => {
  window.localStorage.removeItem(STORAGE.WS_TOKEN);
  window.localStorage.removeItem(STORAGE.WS_USER_ID);
  window.localStorage.removeItem(STORAGE.WS_USER_EMAIL);
  window.localStorage.removeItem(STORAGE.WS_SELECTED_COMPANY);
  window.sessionStorage.removeItem(STORAGE.WS_REDIRECT_URL);
  getNavigateFn()('/login');
};

var userService = /*#__PURE__*/Object.freeze({
	__proto__: null,
	fetchCurrentUserInfo: fetchCurrentUserInfo,
	fetchCurrentUserPayrollProfile: fetchCurrentUserPayrollProfile,
	logout: logout,
	clientLogout: clientLogout
});

function fetchCompanies() {
  return getRequestInstance().get('/v1/users/companies');
}
function fetchBrands(nickname) {
  return getRequestInstance().get(`/v1/companies/${nickname}/brands`);
}

var companyService = /*#__PURE__*/Object.freeze({
	__proto__: null,
	fetchCompanies: fetchCompanies,
	fetchBrands: fetchBrands
});

var DESCRIPTORS = descriptors;
var fails$2 = fails$c;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$4;
var IndexedObject$1 = indexedObject;

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails$2(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var $$2 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$$2({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

function fetchNotificationList(params) {
  return getRequestInstance().get('/v1/notifications', {
    params: Object.assign(Object.assign({}, params), {
      status: params.status === 'all' ? '' : params.status
    })
  });
}
function fetchNotificationDetail(notificationId) {
  return getRequestInstance().get('/v1/notifications/:id'.replace(':id', String(notificationId)));
}
function markAllNotificationsAsRead() {
  return getRequestInstance().get('/v1/notifications/read_all');
}
function markNotificationAsRead(notificationId) {
  return getRequestInstance().get('/v1/notifications/:id/read'.replace(':id', String(notificationId)));
}
function markNotificationAsUnread(notificationId) {
  return getRequestInstance().get('/v1/notifications/:id/unread'.replace(':id', String(notificationId)));
}

var notificationService = /*#__PURE__*/Object.freeze({
	__proto__: null,
	fetchNotificationList: fetchNotificationList,
	fetchNotificationDetail: fetchNotificationDetail,
	markAllNotificationsAsRead: markAllNotificationsAsRead,
	markNotificationAsRead: markNotificationAsRead,
	markNotificationAsUnread: markNotificationAsUnread
});

function fetchAvailableAccountPermission() {
  return getRequestInstance().get('/v1/settings/permissions');
}

var permissionService = /*#__PURE__*/Object.freeze({
	__proto__: null,
	fetchAvailableAccountPermission: fetchAvailableAccountPermission
});

function fetchGrowthBookFeatures() {
  return getRequestInstance().get('/v1/growthbook_features');
}

var growthbookService = /*#__PURE__*/Object.freeze({
	__proto__: null,
	fetchGrowthBookFeatures: fetchGrowthBookFeatures
});

function isSurveyRecipientInFormsAnEmployeeRecord(recipient) {
  return recipient.recipient_type === 'EmployeeRecord';
}
function isSurveyRecipientInResponseAnEmployeeRecord(recipient) {
  return recipient.recipient_type === 'EmployeeRecord';
}

function getRedirectUrl() {
  return window.sessionStorage.getItem(STORAGE.WS_REDIRECT_URL);
}
function setRedirectUrl(url) {
  window.sessionStorage.setItem(STORAGE.WS_REDIRECT_URL, url);
}
function removeRedirectUrl() {
  window.sessionStorage.removeItem(STORAGE.WS_REDIRECT_URL);
}

var sessionStorage = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getRedirectUrl: getRedirectUrl,
	setRedirectUrl: setRedirectUrl,
	removeRedirectUrl: removeRedirectUrl
});

const getHelloSignClientId = currentEnv => {
  let getHelloSignClientId = '';
  switch (currentEnv) {
    case 'production':
      getHelloSignClientId = 'f83ba7bc9a42dd1a16a4d50ae7c4d20a';
      break;
    case 'trunk':
      getHelloSignClientId = '3830caf892ed60156f7d18ff054fa354';
      break;
    case 'staging':
      getHelloSignClientId = '5a219c5403011d3eb59fda76c2c652db';
      break;
    case 'staging-1':
      getHelloSignClientId = '3b412e4e99c925f49f8893c60cabe12a';
      break;
    case 'staging-2':
      getHelloSignClientId = 'c71a647d5b333464a97ca6f097c87fa9';
      break;
    case 'staging-3':
    case 'mfe-dev':
      getHelloSignClientId = 'b4b70fe61a3a6c26c5cf9be6ab947fe1';
      break;
    case 'staging-4':
      getHelloSignClientId = 'f2fce69f1167948fbd7d6599098503a0';
      break;
    case 'staging-seed':
      getHelloSignClientId = '4ce491dc03205c76115ed7226b9e3c1b';
      break;
    case 'sandbox':
      getHelloSignClientId = '8e48e3a39e8c7b188daeedd8ac3686e8';
      break;
    case 'playground':
      getHelloSignClientId = '3b412e4e99c925f49f8893c60cabe12a';
      break;
    default:
      getHelloSignClientId = '1229905e27e23c3355cfe3c0e25c3cd3';
      break;
  }
  return getHelloSignClientId;
};

function useCurrentUserInfo(options = {}) {
  return useQuery(Object.assign(Object.assign({
    queryKey: [QUERY_KEYS.CURRENT_USER_INFO],
    queryFn: () => fetchCurrentUserInfo(),
    select: data => data.user,
    refetchOnWindowFocus: false
  }, options), {
    initialData: () => ({
      user: {
        bell_notifications_count: 0,
        unread_notifications_count: 0,
        company_admin: {
          permissions: []
        },
        company: {
          id: 0,
          status: '',
          onboarding_activated_at: '',
          function_modules: [],
          name: null,
          nickname: null,
          number: null,
          paid_locations_count: null,
          plan_type: null,
          platform: null,
          share_number: null,
          source: null,
          tier: null,
          trial: null,
          trial_remaining_days: null,
          wotc_pre_questionnaire_enabled: null,
          company_created_at: null,
          tiers: null,
          used_locations_count: null,
          brands: []
        },
        id: null,
        avatar: null,
        created_at: null,
        disabled: null,
        email: null,
        first_name: null,
        global_phone_number_for_sms: null,
        has_multiple_companies: null,
        is_general_manager: null,
        is_super_admin: null,
        is_support_staff: null,
        last_name: null,
        name: null,
        onboarding_need_attention_count: null,
        onboarding_step: null,
        phone: null,
        podding_sign_up_step: null,
        pop_up_notifications: null,
        region_number: null,
        reset_password_required: null,
        start_wizard_flag: null,
        status: null,
        super_admin_onboarding_step: null,
        title: null,
        user_id: null,
        user_onboarding_desktop_step: null,
        user_onboarding_mobile_step: null,
        uuid: null,
        access_to_all_locations_and_departments: false
      }
    })
  }));
}
function useCurrentUserPayrollProfile(options = {
  enabled: false
}) {
  return useQuery({
    enabled: options.enabled,
    queryKey: [QUERY_KEYS.CURRENT_USER_PAYROLL_PROFILE],
    queryFn: () => fetchCurrentUserPayrollProfile(),
    refetchOnWindowFocus: false,
    initialData: () => ({
      id: '',
      user_id: '',
      first_name: '',
      last_name: '',
      middle_name: null,
      email: '',
      phone: '',
      active: false,
      created_at: '',
      updated_at: '',
      last_visit_at: ''
    })
  });
}
function useLogout() {
  return useMutation(() => logout());
}

var fails$1 = fails$c;

var correctPrototypeGetter = !fails$1(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$1 = has$a;
var toObject$1 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject$1(O);
  if (has$1(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var getPrototypeOf$1 = objectGetPrototypeOf;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$8;
var has = has$a;
var wellKnownSymbol$2 = wellKnownSymbol$g;

var ITERATOR$2 = wellKnownSymbol$2('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype$2 == undefined) IteratorPrototype$2 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has(IteratorPrototype$2, ITERATOR$2)) {
  createNonEnumerableProperty$2(IteratorPrototype$2, ITERATOR$2, returnThis$2);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$3;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isObject = isObject$8;

var aPossiblePrototype$1 = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

var anObject = anObject$c;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$1 = _export;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$8;
var redefine = redefine$5.exports;
var wellKnownSymbol$1 = wellKnownSymbol$g;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$1('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
          createNonEnumerableProperty$1(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty$1(IterablePrototype, ITERATOR$1, defaultIterator);
  }
  Iterators$1[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$1({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject = toIndexedObject$4;
var addToUnscopables = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineIterator = defineIterator$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

var aFunction = aFunction$5;
var toObject = toObject$4;
var IndexedObject = indexedObject;
var toLength = toLength$5;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var fails = fails$c;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $ = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var arrayMethodUsesToLength = arrayMethodUsesToLength$2;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var global$1 = global$i;
var DOMIterables = domIterables;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$8;
var wellKnownSymbol = wellKnownSymbol$g;

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}

function addLevelInfoToItem(item, level, ancestors) {
  var _a, _b;
  const result = Object.assign(Object.assign(Object.assign({}, item), {
    level
  }), ancestors && {
    ancestors
  });
  if (!item.children) return result;
  if (item.children.length === 0) return result;
  const nextLevel = level + 1;
  // eslint-disable-next-line
  ancestors = [...ancestors, item.key];
  result.children = (_b = (_a = result === null || result === void 0 ? void 0 : result.children) === null || _a === void 0 ? void 0 : _a.map(record => addLevelInfoToItem(record, nextLevel, ancestors))) !== null && _b !== void 0 ? _b : [];
  return result;
}
function flattenAvailablePermissionsFn(acc, item) {
  if (item.children == null) {
    return [...acc, item];
  }
  if (item.children.length === 0) {
    return [...acc, item];
  }
  return [item, ...item.children.reduce(flattenAvailablePermissionsFn, [...acc])];
}
function parseAvailablePermissions(rawAvailablePermissions) {
  const availablePermissions = rawAvailablePermissions.map(item => {
    return addLevelInfoToItem(item, 0, []);
  });
  const flattenAvailablePermissions = availablePermissions.reduce(flattenAvailablePermissionsFn, []);
  return {
    availablePermissions,
    flattenAvailablePermissions
  };
}
function hasUserPermissionV2(userPermissions, flattenAvailablePermissions, permissionKey) {
  if (_.isEmpty(userPermissions)) {
    return false;
  }
  if (userPermissions.includes(permissionKey)) {
    return true;
  }
  const foundPermission = _.find(flattenAvailablePermissions, {
    key: permissionKey
  });
  // If found permission doesn't have child permissions, stop checking
  if (!foundPermission || !foundPermission.children || foundPermission.children.length === 0) {
    return false;
  }
  const childKeys = (foundPermission.children || []).reduce(flattenAvailablePermissionsFn, []).map(item => item.key);
  if (_.intersection(childKeys, userPermissions).length > 0) {
    return true;
  }
  return false;
}
function useAvailablePermissions() {
  return useQuery({
    queryKey: [QUERY_KEYS.AVAILABLE_PERMISSIONS],
    queryFn: () => fetchAvailableAccountPermission(),
    select: data => data.permissions,
    initialData: () => ({
      permissions: []
    }),
    refetchOnWindowFocus: false
  });
}
function useUserPermission(permissionKey) {
  var _a, _b;
  const {
    data
  } = useCurrentUserInfo();
  return (_b = (_a = data === null || data === void 0 ? void 0 : data.company_admin) === null || _a === void 0 ? void 0 : _a[permissionKey]) !== null && _b !== void 0 ? _b : false;
}
function useUserPermissionV2(permissionKey) {
  var _a, _b;
  const {
    data: currentUserInfo
  } = useCurrentUserInfo();
  const {
    data: rawAvailablePermissions
  } = useAvailablePermissions();
  const userPermissions = (_b = (_a = currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.company_admin) === null || _a === void 0 ? void 0 : _a.permissions) !== null && _b !== void 0 ? _b : [];
  const {
    flattenAvailablePermissions
  } = parseAvailablePermissions(rawAvailablePermissions);
  return hasUserPermissionV2(userPermissions, flattenAvailablePermissions, permissionKey);
}
function getViewSensitivePiiPermission(data, key = '') {
  var _a, _b;
  const targetPermissionItem = (_b = (_a = data === null || data === void 0 ? void 0 : data.company_admin) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.find(permissionItem => typeof permissionItem === 'object' && Object.keys(permissionItem).includes(key));
  if (!targetPermissionItem) return;
  const piiPermissionItem = targetPermissionItem;
  return piiPermissionItem[key];
}
function useHasPiiFullAccess() {
  const {
    data
  } = useCurrentUserInfo();
  return getViewSensitivePiiPermission(data, USER_PERMISSIONS.VIEW_SENSITIVE_PII) === VIEW_SENSITIVE_PII.FULL_ACCESS;
}
const fullWorkerPiiAccess = {
  hasWorkerPiiPartialAccess: true,
  hasWorkerPiiFullAccess: true,
  canViewSensitiveWorkerInfo: true
};
const partialWorkerPiiAccess = {
  hasWorkerPiiPartialAccess: true,
  hasWorkerPiiFullAccess: false,
  canViewSensitiveWorkerInfo: true
};
const noWorkerPiiAccess = {
  hasWorkerPiiPartialAccess: false,
  hasWorkerPiiFullAccess: false,
  canViewSensitiveWorkerInfo: false
};
function useWorkerPiiAccess() {
  const {
    data: user
  } = useCurrentUserInfo();
  const workerPii = getViewSensitivePiiPermission(user, USER_PERMISSIONS.MANAGE_TEAM_RECORD);
  if (workerPii === VIEW_WORKER_SENSITIVE_PII.FULL_ACCESS) {
    return fullWorkerPiiAccess;
  }
  if (workerPii === VIEW_WORKER_SENSITIVE_PII.PARTIAL_ACCESS) {
    return partialWorkerPiiAccess;
  }
  return noWorkerPiiAccess;
}

function useHasFunctionModule(functionModuleKey, options = {}) {
  var _a, _b;
  const {
    data
  } = useCurrentUserInfo(options);
  return (_b = (_a = data === null || data === void 0 ? void 0 : data.company) === null || _a === void 0 ? void 0 : _a.function_modules) === null || _b === void 0 ? void 0 : _b.includes(functionModuleKey);
}
function useHasFunctionModuleObj(functionModuleKey) {
  var _a, _b;
  const {
    data,
    isFetched
  } = useCurrentUserInfo();
  return {
    isFetched,
    data: isFetched ? (_b = (_a = data === null || data === void 0 ? void 0 : data.company) === null || _a === void 0 ? void 0 : _a.function_modules) === null || _b === void 0 ? void 0 : _b.includes(functionModuleKey) : undefined
  };
}

function useCompanies() {
  return useQuery({
    queryKey: [QUERY_KEYS.COMPANIES],
    queryFn: () => fetchCompanies(),
    select: data => data.companies,
    initialData: () => ({
      companies: []
    })
  });
}
function useBrands(nickname) {
  return useQuery({
    queryKey: [QUERY_KEYS.BRANDS],
    initialData: () => ({
      brands: []
    }),
    enabled: !!nickname,
    queryFn: () => fetchBrands(nickname),
    select: data => data.brands
  });
}

function useNotificationList(params) {
  return useQuery({
    queryKey: [QUERY_KEYS.NOTIFICATION_LIST, params],
    queryFn: () => fetchNotificationList(params),
    select: data => data.notifications,
    initialData: () => ({
      notifications: [],
      unread_count: 0,
      latest_count: 0,
      next_page: 0
    })
  });
}
function useNotificationDetail(notificationId) {
  return useQuery({
    queryKey: [QUERY_KEYS.NOTIFICATION_DETAIL, notificationId],
    queryFn: () => fetchNotificationDetail(notificationId),
    select: data => data.notification,
    initialData: () => ({
      notification: {}
    })
  });
}
function useMarkAllNotificationsAsRead() {
  return useMutation(() => markAllNotificationsAsRead());
}
function useMarkNotificationAsRead() {
  return useMutation(notificationId => markNotificationAsRead(notificationId));
}
function useMarkNotificationAsUnread() {
  return useMutation(notificationId => markNotificationAsUnread(notificationId));
}

/*
 * @growthbookFeature the feature you want to keep track of
 * @customKey what you want your localStorage key to be
 *
 * toggleFeature() will toggle the localStorage key on and off
 * isDesignFeatureOn returns growthbookFeature && localStorage
 */
function useNFW(growthbookFeature = false, customKey = '') {
  const [localNFW, setLocalNFW] = useState(window.localStorage.getItem(customKey) === 'true');
  const isDesignFeatureOn = useMemo(() => {
    return localNFW && growthbookFeature;
  }, [localNFW, growthbookFeature]);
  const toggleFeature = useCallback(() => {
    window.localStorage.setItem(customKey, `${!localNFW}`);
    setLocalNFW(prev => !prev);
  }, [localNFW, customKey]);
  return {
    isDesignFeatureOn,
    toggleFeature
  };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const SegmentAnalyticsContext = /*#__PURE__*/createContext(null);
function SegmentAnalyticsProvider(props) {
  const {
    children,
    writeKey,
    analytics
  } = props;
  const hasSegCtx = useRef(false);
  const [userInfo, setUserInfo] = useState(null);
  const [analyticsCtx, setAnalyticsCtx] = useState();
  useEffect(() => {
    if (writeKey && !analytics && !hasSegCtx.current && userInfo) {
      const instance = new AnalyticsBrowser();
      instance.load({
        writeKey
      });
      const restUserInfoProps = __rest(userInfo, ["userId"]);
      instance.identify(userInfo.userId, Object.assign({}, restUserInfoProps));
      setAnalyticsCtx(instance);
      hasSegCtx.current = true;
    }
  }, [writeKey, setAnalyticsCtx, analytics, userInfo]);
  useEffect(() => {
    if (analytics && !hasSegCtx.current) {
      setAnalyticsCtx(analytics);
      hasSegCtx.current = true;
    } else {
      fetchCurrentUserInfo().then(userInfoResponse => {
        var _a, _b;
        const user = (userInfoResponse === null || userInfoResponse === void 0 ? void 0 : userInfoResponse.user) || {};
        const userInfo = {
          userId: String(user === null || user === void 0 ? void 0 : user.user_id),
          name: String(user === null || user === void 0 ? void 0 : user.name),
          companyName: ((_a = user === null || user === void 0 ? void 0 : user.company) === null || _a === void 0 ? void 0 : _a.name) || '',
          companyId: String((_b = user === null || user === void 0 ? void 0 : user.company) === null || _b === void 0 ? void 0 : _b.id),
          email: (user === null || user === void 0 ? void 0 : user.email) || '',
          uuid: (user === null || user === void 0 ? void 0 : user.uuid) || '',
          createdAt: (user === null || user === void 0 ? void 0 : user.created_at) || ''
        };
        setUserInfo(userInfo);
      }).catch(e => {
        console.error(e);
      });
    }
  }, [analytics, setAnalyticsCtx]);
  return jsx(SegmentAnalyticsContext.Provider, Object.assign({
    value: {
      analytics: analyticsCtx
    }
  }, {
    children: children
  }));
}
function useSegmentAnalytics() {
  const segmentContext = useContext(SegmentAnalyticsContext);
  return {
    analytics: segmentContext === null || segmentContext === void 0 ? void 0 : segmentContext.analytics,
    segmentContext
  };
}

const getSurveyList = params => getRequestInstance().get('/v1/surveys', {
  params
});

const useSurveyList = (apiParams, queryOptions, enabled = false) => {
  const {
    data,
    isLoading,
    refetch,
    isRefetching
  } = useQuery(Object.assign({
    queryKey: [QUERY_KEYS.SURVEY_LIST, apiParams],
    queryFn: () => getSurveyList(apiParams),
    refetchOnWindowFocus: false,
    initialData: () => ({
      surveys: [],
      meta: {}
    })
  }, queryOptions));
  return {
    data,
    isLoading: isLoading || isRefetching,
    refetch,
    surveys: (data === null || data === void 0 ? void 0 : data.surveys) || [],
    meta: (data === null || data === void 0 ? void 0 : data.meta) || {}
  };
};

function useGrowthBookFeatures({
  enabled = true
}) {
  return useQuery({
    queryKey: [],
    queryFn: () => fetchGrowthBookFeatures(),
    enabled
  });
}

/**
 * https://workstream-api-portal.redoc.ly/openapi/integration/overview
 *
 * Implements the Integration API module
 *
 * Workstream Internal API (1.0.0)
 */
function fetchEmployerTaxEntities(includeLocations = false) {
  return getRequestInstance().get('/v1/employer_tax_infos', {
    params: {
      include: includeLocations ? 'locations' : undefined
    }
  });
}

function useCompanyEmployerTaxInfo(includeLocations = false) {
  return useQuery({
    queryKey: ['employer_tax_infos'],
    queryFn: () => {
      return fetchEmployerTaxEntities(includeLocations);
    }
  });
}

function fetchCustomFields(entityType) {
  return getRequestInstance().get(`/v1/entity_types/${entityType}/custom_fields/`);
}

function validTextField(value, customField) {
  const config = customField.config || {};
  if (value && config.character_blacklist) {
    const re = /[&*{}[\],=\-()+;.’'/]/;
    if (re.test(value)) {
      return {
        valid: false,
        error_reason: 'invalid_characters',
        error: "Cannot enter special characters (& * {} [ ] , = - ( ) . + ; ’ ' /)"
      };
    }
  }
  if (value && value.length > 100) {
    return {
      valid: false,
      error_reason: 'too_long',
      error: 'Text field must be less than 100 characters'
    };
  }
  return {
    valid: true,
    error: ''
  };
}
function validSelectField(value, customField) {
  const options = customField.options || [];
  if (value && !options.includes(value)) {
    return {
      valid: false,
      error_reason: 'invalid_option',
      error: 'Invalid option'
    };
  }
  return {
    valid: true,
    error: ''
  };
}
function validDateField(value, customField) {
  if (value && Number.isNaN(Date.parse(value))) {
    return {
      valid: false,
      error_reason: 'invalid_date',
      error: 'Invalid date'
    };
  }
  return {
    valid: true,
    error: ''
  };
}
function validNumberField(value, customField) {
  const config = customField.config || {};
  let digitLength = Number(config.digit_length);
  if (Number.isNaN(digitLength)) digitLength = 0;
  if (value && !/^\d+$/.test(value)) {
    return {
      valid: false,
      error_reason: 'numerical_only',
      error: 'Please enter only numerical values'
    };
  }
  if (value && digitLength > 0 && digitLength < value.length) {
    return {
      valid: false,
      error_reason: 'exceeded_digit_limit',
      error: 'Maximum digit limit exceeded.'
    };
  }
  return {
    valid: true,
    error: ''
  };
}
const validators = {
  text: validTextField,
  select: validSelectField,
  date: validDateField,
  number: validNumberField
};
function CustomFieldFormRenderer(props) {
  const {
    render,
    customField
  } = props;
  const isValid = useCallback(value => {
    if (!value && customField.is_required) {
      return {
        valid: false,
        error_reason: 'required',
        error: 'This is a required field'
      };
    }
    return validators[customField.field_type](value, customField);
  }, [customField]);
  return render({
    isValid
  });
}

function useCustomFields(entityType) {
  return useQuery({
    queryKey: [QUERY_KEYS.CUSTOM_FIELDS, entityType],
    queryFn: () => {
      if (!entityType) {
        return Promise.resolve({
          custom_fields: []
        });
      }
      return fetchCustomFields(entityType);
    },
    select: data => data.custom_fields,
    initialData: () => ({
      custom_fields: []
    }),
    enabled: !!entityType
  });
}

const CurrentUserInfoContext = /*#__PURE__*/createContext(null);
function useCurrentUserInfoContext() {
  const contextValue = useContext(CurrentUserInfoContext);
  if (contextValue === undefined) {
    throw new Error('Must use inside a CurrentUserInfoContext');
  }
  return contextValue;
}
function CurrentUserInfoContextProvider({
  children
}) {
  const {
    data: currentUserInfo
  } = useCurrentUserInfo();
  return jsx(CurrentUserInfoContext.Provider, Object.assign({
    value: {
      currentUserInfo
    }
  }, {
    children: children
  }));
}

function useSetClarityTags() {
  var _a;
  const currentUserInfo = (_a = useCurrentUserInfoContext()) === null || _a === void 0 ? void 0 : _a.currentUserInfo;
  useEffect(() => {
    if (window.clarity == null) {
      console.warn("[Clarity] 'window.clarity' is not available yet thus not able to set tags");
      return;
    }
    if ([currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.user_id, currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.uuid, currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.email].every(tagValue => tagValue != null)) {
      console.info(`[Clarity] set tag 'user_id': ${currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.user_id}`);
      window.clarity('set', 'user_id', String(currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.user_id));
      console.info(`[Clarity] set tag 'user_uuid': ${currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.uuid}`);
      window.clarity('set', 'user_uuid', currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.uuid);
      console.info(`[Clarity] set tag 'user_email': ${currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.email}`);
      window.clarity('set', 'user_email', currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.email);
    }
  },
  // Define dependencies at a more specific level (other than just `currentUserInfo`) to avoid setting Clarity tags
  // repeatedly.
  [currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.user_id, currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.uuid, currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.email]);
}

const service = {
  user: userService,
  company: companyService,
  notification: notificationService,
  permission: permissionService,
  growthbook: growthbookService
};

export { CurrentUserInfoContext, CurrentUserInfoContextProvider, CustomFieldFormRenderer, QUERY_KEYS, STORAGE, SegmentAnalyticsContext, SegmentAnalyticsProvider, USER_PERMISSIONS, VIEW_SENSITIVE_PII, VIEW_WORKER_SENSITIVE_PII, getApiPrefix, getHelloSignClientId, getNavigateFn, getRequestInstance, getTimezoneName, hasUserPermissionV2, isSurveyRecipientInFormsAnEmployeeRecord, isSurveyRecipientInResponseAnEmployeeRecord, localStorage as localStorageUtils, parseAvailablePermissions, service, sessionStorage as sessionStorageUtils, setApiPrefix, setNavigateFn, setRequestInstance, shouldHideGlobalSiders, useAvailablePermissions, useBrands, useCompanies, useCompanyEmployerTaxInfo, useCurrentUserInfo, useCurrentUserInfoContext, useCurrentUserPayrollProfile, useCustomFields, useGrowthBookFeatures, useHasFunctionModule, useHasFunctionModuleObj, useHasPiiFullAccess, useLogout, useMarkAllNotificationsAsRead, useMarkNotificationAsRead, useMarkNotificationAsUnread, useNFW, useNotificationDetail, useNotificationList, useSegmentAnalytics, useSetClarityTags, useSurveyList, useUserPermission, useUserPermissionV2, useWorkerPiiAccess };
